"use strict";

var _createForOfIteratorHelper = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("F:\\Manal Files\\Projects\\StackBeans\\Updated\\StackBeans\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attractor = void 0;

var Utils_1 = require("../../Utils");

var Attractor = /*#__PURE__*/function () {
  function Attractor(container) {
    _classCallCheck(this, Attractor);

    this.container = container;
  }

  _createClass(Attractor, [{
    key: "interact",
    value: function interact(p1) {
      var _a;

      var container = this.container;
      var distance = (_a = p1.linksDistance) !== null && _a !== void 0 ? _a : container.retina.linksDistance;
      var pos1 = p1.getPosition();
      var query = container.particles.quadTree.queryCircle(pos1, distance);

      var _iterator = _createForOfIteratorHelper(query),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p2 = _step.value;

          if (p1 === p2 || !p2.particlesOptions.move.attract.enable || p2.destroyed || p2.spawning) {
            continue;
          }

          var pos2 = p2.getPosition();

          var _Utils_1$NumberUtils$ = Utils_1.NumberUtils.getDistances(pos1, pos2),
              dx = _Utils_1$NumberUtils$.dx,
              dy = _Utils_1$NumberUtils$.dy;

          var rotate = p1.particlesOptions.move.attract.rotate;
          var ax = dx / (rotate.x * 1000);
          var ay = dy / (rotate.y * 1000);
          p1.velocity.horizontal -= ax;
          p1.velocity.vertical -= ay;
          p2.velocity.horizontal += ax;
          p2.velocity.vertical += ay;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.particlesOptions.move.attract.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return Attractor;
}();

exports.Attractor = Attractor;